import SwiperCore, { Autoplay, EffectCoverflow, Pagination } from 'swiper';
import { Component, ViewEncapsulation } from '@angular/core';


SwiperCore.use([Autoplay, EffectCoverflow, Pagination]);

@Component({
  selector: 'app-midia',
  templateUrl: './midia.component.html',
  styleUrls: ['./midia.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MidiaComponent {
  carrousels: { title: string; images: string[] }[] = [
    {
      title: 'Comemorações de 40 FPLF',
      images: [
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_1.jpg',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_2.jpg',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_4.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_4.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_5.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_6.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_7.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_8.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_9.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_10.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_11.JPG',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_12.jpg',
        '../../../assets/imagens/Comemoracoes_de_40_FPLF/40_FPLF_13.JPG',
      ],
    },
    {
      title: 'Fotos Medalha Pedro Ernesto',
      images: [
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_1.JPG',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_2.jpg',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_3.jpg',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_4.jpg',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_5.JPG',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_6.JPG',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_7.JPG',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_8.JPG',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_9.JPG',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_10.jpg',
        '../../../assets/imagens/Fotos_Medalha_Pedro_Ernesto/Medalha_Pedro_Ernesto_11.jpg',
      ],
    },
    {
      title: 'Casa de Inovação',
      images: [
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_1837.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_1899.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_1910.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_5078.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_5164.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_5180.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_5203.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_5226.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/IMG_5229.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/ECOAnaCasa_CaseAlterdata_14maio24.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/ECOAnaCasa_LeonardoSoares_9abril24.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_CONSULADODOJAPAO1_12marco24.jpeg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_CONSULADOJAPAO2_12marco24.jpeg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_ESTHERRODRIGUEZ_RODADECONVERSA_6MARCO24.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_OBSERVATORIORIODEIMPACTO1_27marco24.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_OBSERVATORIORIODEIMPACTO2_27marco24.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_OBSERVATORIORIODEIMPACTO3_27marco24.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_PARCERIAIPP_9abril24.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_PITCHDAYSUSTENTABILIDADE1_7maio24.jpg',
        '../../../assets/imagens/JORNADASDEINOVACAO/EVENTO_PITCHDAYSUSTENTABILIDADE2_7maio24.jpg',
      ],
    },
    {
      title: 'Missão institucional na China',
      images: [
        '../../../assets/imagens/Viagem_China_2025/1736203846900.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736203847224.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736203847784.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736368846052.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736368846449.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736368846753.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736368847177.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736368847314.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736368847960.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736516231618.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736516232170.jpeg',
        '../../../assets/imagens/Viagem_China_2025/1736516232999.jpeg',
      ],
    },
    {
      title: 'Aula Magistral',
      images: [
        '../../../assets/imagens/Aula_Magistral/NMP_8419.JPG',
        '../../../assets/imagens/Aula_Magistral/NMP_8490.JPG',
        '../../../assets/imagens/Aula_Magistral/NMP_8492.JPG',
        '../../../assets/imagens/Aula_Magistral/NMP_8609.JPG',
        '../../../assets/imagens/Aula_Magistral/NMP_8626.JPG',
        '../../../assets/imagens/Aula_Magistral/NMP_8633.JPG',
      ],
    },
    {
      title:
        'Lançamento da Pedra Fundamental do Instituto de Inteligência Artificial/PUC-Rio - 15.08.2025',
      images: [
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8013.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8023.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8028.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8084.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8091.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8094.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8101.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8103.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8105.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8126.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8133.JPG',
        '/assets/imagens/Lancamento_da_Pedra_Fundamental/IMG_8157.JPG',
      ],
    },
    {
      title:
        '60 anos de docência - Prof . Carlos José P. de Lucena - Superintendente da Fundação Padre Leonel Franca <br /> Confraternização de Professores e Funcionários Técnico-Administrativos da PUC-RIO - 16/10/2025',
      images: [
        '/assets/imagens/60_Anos_de_Docencia/NMP_5781.jpg',
        '/assets/imagens/60_Anos_de_Docencia/NMP_5782.JPG',
        '/assets/imagens/60_Anos_de_Docencia/NMP_5815.JPG',
        '/assets/imagens/60_Anos_de_Docencia/NMP_5818.JPG',
        '/assets/imagens/60_Anos_de_Docencia/NMP_5836.JPG',
        '/assets/imagens/60_Anos_de_Docencia/NMP_5839.JPG',
        '/assets/imagens/60_Anos_de_Docencia/NMP_5841.JPG',
        '/assets/imagens/60_Anos_de_Docencia/NMP_5842.JPG',
      ],
    },
  ];
}
